import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Dispatches `drilldown:closed` when a drill-down was showing, so a modal around it (dashboards) closes too.
  close(event) {
    event?.preventDefault()
    const showing = this.element.hasAttribute('src')
    this.element.removeAttribute('src')
    this.element.innerHTML = ''
    if (showing) this.dispatch('closed')
  }
}
